import styled from "styled-components";

export const ActionButtonsContainer = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
`;

